/* eslint-disable react/jsx-no-target-blank */
/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Link} from 'react-router-dom'
import clsx from 'clsx'
import {useLayout} from '../../core'
import {toAbsoluteUrl} from '../../../helpers'
import {useIntl} from 'react-intl'
import {ManagementAsideMenu} from './ManagementAsideMenu'

const ManagementAsideDefault: FC = () => {
  const {classes} = useLayout()
  const intl = useIntl()
  return (
    <div
      id='kt_aside'
      className={clsx('aside pb-5 pt-5 pt-lg-0 ', classes.aside.join(' '))}
      data-kt-drawer='true'
      data-kt-drawer-name='aside'
      data-kt-drawer-activate='{default: true, lg: false}'
      data-kt-drawer-overlay='true'
      data-kt-drawer-width="{default:'80px', '300px': '100px'}"
      data-kt-drawer-direction='start'
      data-kt-drawer-toggle='#kt_aside_mobile_toggle'
    >
      {/* begin::Brand */}
      <div className='aside-logo  py-8' id='kt_aside_logo'>
        <Link to='/dashboard' className='d-flex align-items-center'>
          <img src={toAbsoluteUrl('/media/logos/light.svg')} alt='logo' className='h-35px logo' />
        </Link>
      </div>
      {/* end::Brand */}

      {/* begin::Aside menu */}
      <div className='aside-menu flex-column-fluid' id='kt_aside_menu'>
        {/* begin::Nav */}
        <ManagementAsideMenu asideMenuCSSClasses={classes.asideMenu} />
        {/* end::Nav */}

        {/* end::Aside menu */}
      </div>
      {/* begin::Footer */}
      <div className='aside-footer flex-column-auto' id='kt_aside_footer'>
        {/* My Device */}
        <div id='kt_mydevice_toggle' className={clsx('menu-item d-flex justify-content-center ')}>
          {/* begin::Drawer toggle */}
          <a
            target='_blank'
            className={clsx('btn btn-custom w-100 btn-icon btn-active-color-primary px-2')}
            style={{backgroundColor: '#1B1B28'}}
          >
            <i className='ki-duotone ki-technology fs-2hx text-warning mx-1'>
              <span className='path1'></span>
              <span className='path2'></span>
              <span className='path3'></span>
              <span className='path4'></span>
              <span className='path5'></span>
              <span className='path6'></span>
              <span className='path7'></span>
              <span className='path8'></span>
              <span className='path9'></span>
            </i>
            <span className='btn-label' style={{color: '#6B6C7B'}}>
              {intl.formatMessage({id: 'SLIDEMENU.MYDEVICE'})}
            </span>
          </a>
        </div>

        {/* end::Menu */}
      </div>
      {/* end::Footer */}
    </div>
  )
}

export {ManagementAsideDefault}
